module.exports = __webpack_public_path__ + "media/src/images/icon__facebook--dark-06e947a8d01c5ec9df56b30b56b9b2ca.png";